import {Avatar, Box, Chip} from "@mui/material"
import React, {useCallback} from "react"
import Icon from "./BadgeIcons/Icon"

const iconMap = {
    success: <Icon color="#fff" iconName="Check" size="inherit" />,
    error: <Icon color="#fff" iconName="Cross" size="inherit" />,
}

const avatarPlaceholder = " "

const BadgeEvaluationWidget = ({widget, value}) => {
    const label = widget.text
    const variant = value > 0 ? "success" : "error"
    const hasIcon = true

    const getAvatarByProps = useCallback(() => {
        return label ? (
            hasIcon ? (
                <Avatar>{iconMap[variant]}</Avatar>
            ) : undefined
        ) : (
            <Avatar>{avatarPlaceholder}</Avatar>
        )
    }, [label, hasIcon, variant])

    return (
        <Box width="100%" display="flex" alignItems="center" justifyContent="center">
            <Chip
                avatar={getAvatarByProps()}
                label={value > 0 ? "+".repeat(value) : "-".repeat(Math.abs(value))}
                color={variant}
            />
        </Box>
    )
}

export default BadgeEvaluationWidget
